export default __webpack_public_path__ + "static/media/exploded-view_sprite.057a6b0e.png";